import React from 'react';
import InfiniteScrollList from '../../commonComponents/util/InfiniteScrollList';
import ExternalParticipantsListRecord from './ExternalParticipantsListRecord';

export default class ExternalParticipantsInfiniteList extends React.Component {

    getListRecord = participant => {
        const {
            isBatched, isIsraeli, isOrgList,
            listType, listTypes,
            deselected, selected
        } = this.props;

        const isReceiving =
            selected.indexOf(participant.externalListMemberId) >= 0 ? true
                : deselected.indexOf(participant.externalListMemberId) >= 0 ? false
                    : participant.isReceiving;

        return <ExternalParticipantsListRecord
            key={participant.externalListMemberId}
            isBatched={isBatched}
            isIsraeli={isIsraeli}
            isOrgList={isOrgList}
            isReceivedRecord={isBatched && listType === listTypes.Received}
            participant={{
                ...participant,
                isReceiving
            }}
            toggleRemoveRestore={this.props.toggleRemoveRestoreParticipant}
            select={this.props.selectParticipant}
            update={this.props.updateParticipant} />;
    }

    getColumns = () => {
        const {
            data: { allSelected, totalCount },
            isBatched, isIsraeli, isOrgList,
            listType, listTypes,
            loading, savingSelection
        } = this.props;

        return [
            ...isBatched
                ? [
                    {
                        id: 'isReceiving', title: '', sortable: true, defaultDirection: 'Descending',
                        component:
                            <div className={`custom-check-container ${(loading || !totalCount) ? "disabled" : ""}`}>
                                <input type="checkbox"
                                    id="external-participants-select-all"
                                    className="custom-check"
                                    onChange={e => this.props.selectAllParticipantsToggle(e.target.checked ? "all" : "none")}
                                    checked={totalCount && allSelected}
                                    disabled={loading || !totalCount || savingSelection} />
                                <label htmlFor="external-participants-select-all" className="secondary-text" title="Select All" />
                            </div>
                    }
                ] : [],
            { id: 'name', title: 'Name', sortable: true },
            ...(isBatched && listType === listTypes.Received)
                ? [
                    {
                        id: 'numberOfTimesReceived', title: 'Received Count', sortable: false
                    }
                ] : [],
            { id: 'phone', title: 'Phone', sortable: false },
            { id: 'address', title: 'Address', sortable: false },
            ...isIsraeli
                ? [
                    { id: 'teudatZehut', title: 'Teudat Zehut', sortable: false },
                    { id: 'bankNumber', title: 'Bank Number', sortable: false },
                    { id: 'branchNumber', title: 'Branch Number', sortable: false },
                    { id: 'accountNumber', title: 'Account Number', sortable: false },
                    { id: 'accountHolder', title: 'Account Holder', sortable: false }
                ] : [],
            ...(!isIsraeli && isOrgList)
                ? [
                    { id: 'position', title: 'Position', sortable: false },
                ] : [],
            { id: 'edit', title: 'Edit', sortable: false },
            { id: 'delete', title: 'Delete', sortable: false }

        ];
    }

    render() {
        const {
            data: { records, totalCount },
            hasMore,
            listType,
            loading,
            page,
            sort,
            success
        } = this.props;

        const columns = this.getColumns();

        return <div>
            <InfiniteScrollList
                columns={columns}
                getRecords={this.props.getParticipants}
                hasMore={hasMore}
                loading={loading}
                name={`${listType ? `${listType} ` : ""}campaign list participants`}
                page={page}
                records={records}
                renderRecord={this.getListRecord}
                sort={sort}
                success={success}
                totalCount={totalCount} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/externalLists/ExternalParticipantsInfiniteList.jsx